import React, { Component } from 'react'

import Searchbar from '../../utils/Searchbar'
import SearchStoreLocation from '../../search/SearchStoreLocation'

class StoreLocationSearch extends Component {
    render() {
        return (
            <div>
                <Searchbar placeholder={"Search store locations"} component={SearchStoreLocation} searchEndpoint={'search/store-location'} {...this.props} userType="admin" />
            </div>
        )
    }
}

export default StoreLocationSearch



// WEBPACK FOOTER //
// ./src/components/admin/store-locations/StoreLocationSearch.js